module.exports = __webpack_public_path__ + "img/img4.6b23fa52.svg";